export default "__VITE_ASSET__DEmLs7eu__"